module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_6000.94a19c2a.png";